export const GET_URLUPGRADE_PACKAGE_API_REQUEST = "GET_URLUPGRADE_PACKAGE_API_REQUEST";
export const GET_URLUPGRADE_PACKAGE_API_SUCCESS = "GET_URLUPGRADE_PACKAGE_API_SUCCESS";
export const GET_URLUPGRADE_PACKAGE_API_ERROR = "GET_URLUPGRADE_PACKAGE_API_ERROR";
export const GET_ELITE_REDIRECT_API_SUCCESS = "GET_ELITE_REDIRECT_API_SUCCESS";